import React, { useEffect, useState } from "react";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import useStatsStore from "../engagement_stats/store";
import { isEmpty } from "lodash";
import { TEMP_ENG_ACCESS } from "modules/utilities/utility";
import { IVR_AGENT, LEAD_AGENT, RECEPTIONIST_EXECUTIVE } from "modules/utilities/utility_2";

function SelectAgent({
  name,
  selectedAgent,
  setSelectedAgent,
  agent,
  lead = false,
  level= 1,
  ivr = false,
  clinic = false
}) {
  const { users, fetchUserData } = useStatsStore();
  const [allSelectCount, setAllSelectCount] = useState(1);

  useEffect(() => {
    isEmpty(users) && fetchUserData();
  }, []);

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const optionList = users
    .filter((item) => {
      if (TEMP_ENG_ACCESS.includes(item?.role_id) && !lead && !ivr && !clinic) {
        return true;
      } else if (LEAD_AGENT.includes(item?.role_id) && lead && item?.user?.level === level && !clinic) {
        return true;
      } else if (IVR_AGENT.includes(item?.role_id) && ivr && [4, 5].includes(item?.user?.level) && !clinic) {
        return true;
      } else if(RECEPTIONIST_EXECUTIVE.includes(item?.role_id)){
        return true;
      } else {
        return false;
      }
    })
    .map((item) => {
      return { value: item?.user?.id, label: item?.user?.first_name };
    });
  if (lead || ivr) {
    optionList.unshift({ value: "all", label: "All" });
  }

  function handleSelect(data) {
    const allFlag = data?.filter((item) => item.value == "all");
    if (allFlag?.length > 0 && allSelectCount !== 2 && (lead || ivr || clinic)) {
      const selectedValues = optionList
        ?.filter((item) => item.value !== "all")
        .map((option) => {
          return { value: option?.value, label: option.label };
        });
      const newSelectedAgent = [...selectedAgent, ...selectedValues];
      const uniqueSelectedAgent = [...new Set(newSelectedAgent)];
      setSelectedAgent(uniqueSelectedAgent);
      setAllSelectCount(2);
    } else if (allSelectCount === 2 && (lead || ivr || clinic)) {
      setAllSelectCount(1);
      setSelectedAgent([]);
    } else {
      setSelectedAgent(data);
    }
  }


  const customStyles = {
    container: (provided) => ({
      ...provided,
      minHeight: "2rem",
      maxHeight: "22rem",
    }),
  };

  return (
    <>
      <ReactSelect
        options={optionList}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        placeholder={name}
        components={{
          Option,
        }}
        onChange={handleSelect}
        allowSelectAll={true}
        value={selectedAgent}
        styles={customStyles}
      />
    </>
  );
}

export default SelectAgent;
